module.exports = __webpack_public_path__ + "static/ebr-13-760b36719f35b0717fb6c266c8749bc6.jpg";